import { ListItemIcon, MenuItem } from '@mui/material';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { ActionButtonMenu } from 'components/widgets/RenderLibraryTable/components/ActionMenu/components/ActionButtonMenu/ActionButtonMenu';
import classes from 'components/widgets/RenderLibraryTable/components/ActionMenuError/ActionMenuError.module.scss';

export const ActionMenuError = ({ index, setShowModal, isFileDownload, onDownLoad }) => {
    return (
        <div className={classes.containter}>
            <ActionButtonMenu id={`threeDots_${index}`} tooltipContent={'More Actions'}>
                {isFileDownload && (
                    <MenuItem onClick={onDownLoad}>
                        <ListItemIcon>
                            <MuiIcon icon={'download'} />
                        </ListItemIcon>
                        Download File
                    </MenuItem>
                )}

                <MenuItem onClick={() => setShowModal(true)}>
                    <ListItemIcon>
                        <MuiIcon icon={'delete'} />
                    </ListItemIcon>
                    Delete
                </MenuItem>
            </ActionButtonMenu>
        </div>
    );
};
